module.exports = __webpack_public_path__ + "static/text--home-energy-tips.f9cc9d78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/text--home-energy-tips.svg
// module id = 708
// module chunks = 168707334958949